"use client";

import { Tag } from "@shared/ui/tag";

import { AnimatedBackground } from "~/components/animated-background";
import { JoinWaitListForm } from "~/components/join-waitlist-form";
import { AnimatedGroup } from "~/components/motion-primitives/animated-group";

export const HeroSection = () => {
  return (
    <section className="relative mb-20 overflow-hidden px-4 pt-20 pb-2">
      <div className="absolute inset-x-0 top-0 -z-10 h-full bg-linear-to-b from-[#000A15]/50 to-[#000A15]/100" />
      <AnimatedBackground className="-top-[600px] -right-[430px] scale-75 md:-top-20 md:-right-32 md:scale-90" />
      <AnimatedBackground className="-top-3/4 -left-[400px] hidden lg:block" />
      <AnimatedGroup className="flex flex-col items-center justify-center">
        <Tag type="utility">Coming Soon</Tag>
        <h1 className="my-6 max-w-5xl text-center text-2xl font-semibold drop-shadow-[2px_6px_6px_rgb(255,255,255,0.15)] md:text-5xl md:leading-16">
          Meet Tenki: Runners That Keep Your Cloud Simple and Affordable
        </h1>

        <p className="text-static-secondary mb-12 max-w-sm text-center text-base md:max-w-4xl md:text-xl">
          Set up GitHub Actions runners in no time, delivering quick wins for DevOps without breaking the bank.
        </p>
        <JoinWaitListForm />
        <div className="mt-8 rounded-[20px] border border-white/20 p-px md:mt-20">
          <div className="rounded-[20px] border-8 border-white/[4%]">
            <video
              width="1016"
              height="782.83"
              muted
              loop
              autoPlay
              preload="auto"
              playsInline
              className="rounded-[14px]"
            >
              <source src="https://storage.googleapis.com/tenki-cloud-assets/web/demo.mp4" type="video/mp4" />
              Your browser does not support the video tag.
            </video>
          </div>
        </div>
      </AnimatedGroup>
    </section>
  );
};
